import _ from 'lodash';

import { FilterHierarchy, FilterRange, FilterTerms, SearchFilterValue } from '../model';

export const isFilterTerms = (filter?: SearchFilterValue): filter is FilterTerms => !!filter && Array.isArray(filter);

export const isFilterRange = (filter?: SearchFilterValue): filter is FilterRange =>
    !_.isNil((filter as FilterRange)?.gte) && !_.isNil((filter as FilterRange)?.lte);

export const isFilterHierarchy = (filter?: SearchFilterValue): filter is FilterHierarchy =>
    !_.isNil((filter as FilterHierarchy)?.level) && !_.isNil((filter as FilterHierarchy)?.terms);
